/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Stage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconSubtract from 'DesignSystem/Svgs/TysiaIconSubtract/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import Tysiav2DragHandleIcon from 'DesignSystem/Svgs/Tysiav2DragHandleIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Stage({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/Stages/Stage",
  innerRef,
  dragHandleRef,
  isActive,
  isDragging
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let selectedStageTextValueData = fromData.useDataValue({ viewPath,
context: 'selected_stage',
path: 'text',
})
let selectedStageItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'selected_stage_item',
path: 'isLast',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  innerRef,
  dragHandleRef,
  isActive,
  isDragging
  
})
let selectedStageAutofocusValueData = fromData.useDataValue({ viewPath,
context: 'selected_stage',
path: 'autofocus',
})
let selectedStageItemIsLastValueData1 = fromData.useDataValue({ viewPath,
context: 'selected_stage_item',
path: 'isLast',
})
let selectedStagesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stages',
})
let selectedStageValueData = fromData.useDataValue({ viewPath,
context: 'selected_stage',
})
let aggregateData = fromHelpers.itemDisabled(selectedStageItemIsLastValueData1, selectedStagesValueData, selectedStageValueData)
let selectedStageItemIsLastValueData2 = fromData.useDataValue({ viewPath,
context: 'selected_stage_item',
path: 'isLast',
})
let selectedStagesValueData1 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stages',
})
let selectedStageValueData1 = fromData.useDataValue({ viewPath,
context: 'selected_stage',
})
let aggregateData1 = fromHelpers.itemDisabled(selectedStageItemIsLastValueData2, selectedStagesValueData1, selectedStageValueData1)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  innerRef,
  dragHandleRef,
  isActive,
  isDragging
  
})
let selectedStageItemIsLastValueData3 = fromData.useDataValue({ viewPath,
context: 'selected_stage_item',
path: 'isLast',
})
let selectedStagesValueData2 = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'stages',
})
let selectedStageValueData2 = fromData.useDataValue({ viewPath,
context: 'selected_stage',
})
let aggregateData2 = fromHelpers.itemDisabled(selectedStageItemIsLastValueData3, selectedStagesValueData2, selectedStageValueData2)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Stage.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Stage.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 draghandleref={dragHandleRef}
 style={{'--bc-1-5Mly2': dtColorsNeutral100,'--pl-2-5Mly2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-5Mly2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-5Mly2': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-5-5Mly2': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--mb-6-5Mly2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-7-5Mly2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bblr-8-5Mly2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-9-5Mly2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-10-5Mly2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-11-5Mly2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexGrow={1}
 marginTop={0}
 size="medium"
 data="selected_stage.text"
 value={selectedStageTextValueData}
 onChange={onChange}
 data="selected_stage_item.isLast"
 disabled={selectedStageItemIsLastValueData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 data="selected_stage.autofocus"
 autoFocus={selectedStageAutofocusValueData}
/>
<div
  data-testid="Stage.Vertical:1"
  data-view-path={viewPath}
 ref={dragHandleRef}
 style={{'--c-12-5Mly2': isDragging ? "grabbing" : "grab"}}
 className={`views-block ${styles.Vertical1}`}
>
<fromFlow.When is={!aggregateData}>
<Tysiav2DragHandleIcon
  viewPath={`${viewPath}/Tysiav2DragHandleIcon`}
 data="selected_stage_item.isLast"
 data="selected.stages"
 data="selected_stage"
 aggregate="helpers.js itemDisabled"
/>
</fromFlow.When>
</div>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
<button
  data-testid="Stage.Vertical:2"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--c-12-5Mly2': aggregateData1 ? "not-allowed" : "pointer"}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaIconSubtract
  viewPath={`${viewPath}/TysiaIconSubtract`}
 marginRight={dtSpaceS}
 width={24}
 height={24}
 fill={aggregateData2 ? dtColorsNeutral300 : dtColorsNeutral400}
 data="selected_stage_item.isLast"
 data="selected.stages"
 data="selected_stage"
 aggregate="helpers.js itemDisabled"
/>
</button>
</div>
{children}
</React.Fragment>)
}